/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Text } from 'theme-ui'
import { Fragment } from 'react'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  HeroContainerStyled,
  HeroStyled,
  HeroBackgroundStyled,
  HeroContentStyled,
  HeroTitleStyled,
  HeroSubtitleStyled,
  HeroMediaStyled,
  HeroBlockStyled,
  HeroFormStyled
} from './styles'
import { ContactHeroProps } from './types'
import MediaItem from './../../molecules/MediaItem'
import { BgGradientAltBig, BgGradientAltSmall } from './../../../assets/svg/index'
import ContactForm from '../ContactForm'

const ContactHero: React.FC<ContactHeroProps> = ({ data }) => {
  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  const { title, subtitle, form, media } = data

  const backgroundImage = <Fragment>{isTablet ? <BgGradientAltBig /> : <BgGradientAltSmall />}</Fragment>

  return (
    <HeroContainerStyled>
      <HeroStyled>
        <HeroBackgroundStyled>{backgroundImage}</HeroBackgroundStyled>
        <HeroBlockStyled variant="inners.primary">
          {media ? <HeroMediaStyled>{media.image || media.video.url ? <MediaItem {...{ media }} /> : ''}</HeroMediaStyled> : ''}
          <HeroContentStyled>
            {title && (
              <HeroTitleStyled>
                <Text as="h1">{title}</Text>
              </HeroTitleStyled>
            )}
            {subtitle && (
              <HeroSubtitleStyled>
                <Text as="p">{subtitle}</Text>
              </HeroSubtitleStyled>
            )}
            {form && (
              <HeroFormStyled>
                <ContactForm {...form} />
              </HeroFormStyled>
            )}
          </HeroContentStyled>
        </HeroBlockStyled>
      </HeroStyled>
    </HeroContainerStyled>
  )
}

export default ContactHero
